import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import { withFirebase } from "../../components/Firebase/Firebase";
import Loading from "../../components/Loading/Loading";
import Heading from "../../components/Heading/Heading";
import Button from "../../components/Button/Button";
import AwardItem from "../../components/AwardItem/AwardItem";
import EntryItem from "../../components/EntryItem/EntryItem";
import VideoItem from "../../components/VideoItem/VideoItem";
import _ from 'lodash';
// import VideoShortlist from "../../components/VideoShortlist/VideoShortlist";

class AdminCompetitionDetails extends Component {
	state = {
		activeItem: null
	};
	componentDidMount() {
		if (this.props.competitionId) {
			// If we already have a competition, lets fetch it
			this.props.methods.subscribeToCompetition(this.props.competitionId);
			// We can also fetch the entries to list
			this.props.methods.getCompetitionEntries(this.props.competitionId);
		}
	}
	
	componentWillUnmount() {
		if (this.props.competitionId) {
			this.props.methods.unsubscribeFromCompetition(this.props.competitionId);
		}
	}
	
	addAward = async () => {
		const newAwardId = await this.props.methods.addAwardToCompetition(
			this.props.competitionId
		);
		this.setState({
			activeItem: newAwardId
		});
	};
	
	setActiveItem = activeItem => {
		this.setState({
			activeItem
		});
	};
	
	updateAward = async (awardId, data) => {
		await this.props.methods.updateAward(
			this.props.competitionId,
			awardId,
			data
		);
		this.setState({
			activeItem: null
		});
	};
	
	removeAward = awardId => {
		this.props.methods.removeAward(this.props.competitionId, awardId);
	};
	
	addVideoFromEntry = async entryId => {

		let entry = this.props.entries[entryId],
			video = {
				title: entry.title,
				state: entry.state,
				issue: entry.issue,
				entryId: entryId,
				name: null
			};
		if(!entry) return;

		// Find the first member, get the school name
		_.each(entry.members, (member => {
			if(!video.name && member.schoolName) video.name = member.schoolName;
		}));

		// If none exists simply set the 
		if(!video.name && entry.entry_first_name) {
			video.name = entry.entry_first_name + ' ' + entry.entry_last_name;
		}

		// Create the video
		const videoId = await this.props.methods.addVideoToCompetition(
			this.props.competitionId
		);

		// Copy across the relevant fields to the video item
		this.props.methods.updateVideo(this.props.competitionId, videoId, video);

		// Update the Entry with state 'Added As Video'
		this.props.methods.updateEntryStage(entryId, 9)

		// Open the new video
		this.setState({
			activeItem: videoId
		});

	};
	
	updateVideo = async (videoId, data) => {
		await this.props.methods.updateVideo(
			this.props.competitionId,
			videoId,
			data
		);
		this.setState({
			activeItem: null
		});
	};
	
	removeVideo = videoId => {
		this.props.methods.removeVideo(this.props.competitionId, videoId);
	};
	
	updateVideoThumbnail = async (videoId, filename) => {
		// Fetch a public URL for this filename
		const link = filename ? await this.props.methods.getFileUrl(filename) : "";
		await this.props.methods.updateVideo(this.props.competitionId, videoId, {
			thumbnail: filename,
			publicThumbnail: link
		});
	};
	
	render() {
		if (
			this.props.competitionId &&
			!this.props.competitions[this.props.competitionId]
		) {
			// If we are editing an existing competition but don't yet have the data, return a loading spinner
			return (
				<PageWrapper admin  context="loading">
				<Loading />
				</PageWrapper>
			);
		}
		
		const competitionData = this.props.competitions[this.props.competitionId];
		return (
			<PageWrapper admin  context="awards">
			<section className="section -admin -awards">
			<Heading>Awards</Heading>
			{competitionData.awards &&
				Object.keys(competitionData.awards).map(awardId => (
					<AwardItem
					award={competitionData.awards[awardId]}
					key={awardId}
					expanded={this.state.activeItem === awardId}
					videoOptions={competitionData.videos}
					setExpanded={e => {
						e.preventDefault();
						this.setActiveItem(awardId);
					}}
					handleUpdate={data => this.updateAward(awardId, data)}
					removeSelf={e => {
						e.preventDefault();
						this.removeAward(awardId);
					}}
					/>
				))}
				<Button onClick={this.addAward}>Add Award</Button>
				</section>
				{/* <section className="section -admin -shortlist">
				<Heading>Shortlist</Heading>
				<VideoShortlist videos={competitionData.videos || []} />
			</section> */}
			<section className="section -admin -videos">
			<Heading>Videos</Heading>
			{competitionData.videos &&
				Object.keys(competitionData.videos).map(videoId => (
					<VideoItem
					video={competitionData.videos[videoId]}
					key={videoId}
					id={videoId}
					expanded={this.state.activeItem === videoId}
					setExpanded={e => {
						e.preventDefault();
						this.setActiveItem(videoId);
					}}
					handleUpdate={data => this.updateVideo(videoId, data)}
					handleFileUpload={filename =>
						this.updateVideoThumbnail(videoId, filename)
					}
					removeSelf={e => {
						e.preventDefault();
						this.removeVideo(videoId);
					}}
					/>
				))}
				</section>
				{this.props.entries && (
					<section className="section -admin -entries">
					<Heading>Complete Entries</Heading>
					{Object.keys(this.props.entries)
						.filter(
							entryId => {
							return (this.props.entries[entryId].competition === this.props.competitionId
									&& this.props.entries[entryId].stage === 5
								)
							}
						)
						// Date based sort
						.sort(
							(a, b) => {
								let timea = this.props.entries[a].created ? new Date(this.props.entries[a].created).getTime() : 0;
								let timeb = this.props.entries[b].created ? new Date(this.props.entries[b].created).getTime() : 0;
								return timeb - timea;
							}
						)
						.map(entryId => (
							<EntryItem
							entry={this.props.entries[entryId]}
							key={entryId}
							entryId={entryId}
							expanded={this.state.activeItem === entryId}
							saveAsVideo={e => {
								this.addVideoFromEntry(entryId);
							}}
							setExpanded={e => {
								e.preventDefault();
								this.setActiveItem(entryId);
							}}
							/>
						))}

						<hr />

						<Heading>Incomplete Entries</Heading>
						{Object.keys(this.props.entries)
							.filter(
								entryId => {
								return (this.props.entries[entryId].competition === this.props.competitionId
										&& this.props.entries[entryId].stage < 5
										&& this.props.entries[entryId].title
									)
								}
							)
							// Date based sort
							.sort(
								(a, b) => {
									let timea = this.props.entries[a].created ? new Date(this.props.entries[a].created).getTime() : 0;
									let timeb = this.props.entries[b].created ? new Date(this.props.entries[b].created).getTime() : 0;
									return timeb - timea;
								}
							)
							.map(entryId => (
								<EntryItem
								entry={this.props.entries[entryId]}
								key={entryId}
								entryId={entryId}
								expanded={this.state.activeItem === entryId}
								saveAsVideo={e => {
									this.addVideoFromEntry(entryId);
								}}
								setExpanded={e => {
									e.preventDefault();
									this.setActiveItem(entryId);
								}}
								/>
							))}


							<hr />

							<Heading>Processed Entries</Heading>
							{Object.keys(this.props.entries)
								.filter(
									entryId => {
									return (this.props.entries[entryId].competition === this.props.competitionId
											&& this.props.entries[entryId].stage === 9
										)
									}
								)
								// Date based sort
								.sort(
									(a, b) => {
										let timea = this.props.entries[a].created ? new Date(this.props.entries[a].created).getTime() : 0;
										let timeb = this.props.entries[b].created ? new Date(this.props.entries[b].created).getTime() : 0;
										return timeb - timea;
									}
								)
								.map(entryId => (
									<EntryItem
									entry={this.props.entries[entryId]}
									key={entryId}
									entryId={entryId}
									expanded={this.state.activeItem === entryId}
									saveAsVideo={e => {
										this.addVideoFromEntry(entryId);
									}}
									setExpanded={e => {
										e.preventDefault();
										this.setActiveItem(entryId);
									}}
									/>
								))}

						</section>
					)}
					</PageWrapper>
				);
			}
		}
		
		export default withRouter(withFirebase(AdminCompetitionDetails));
		


// WEBPACK FOOTER //
// ./src/pages/Admin/AdminCompetitionDetails.js